export type AfishaTheme = "light" | "dark";

const STORAGE_KEY = "kudavgorod-theme";
const LEGACY_STORAGE_KEY = "kudgorod-theme";

function readStoredTheme(): AfishaTheme | null {
  try {
    const saved =
      localStorage.getItem(STORAGE_KEY) ?? localStorage.getItem(LEGACY_STORAGE_KEY);
    if (saved === "light" || saved === "dark") {
      if (!localStorage.getItem(STORAGE_KEY) && localStorage.getItem(LEGACY_STORAGE_KEY)) {
        localStorage.setItem(STORAGE_KEY, saved);
      }
      return saved;
    }
  } catch {
    // ignore
  }

  return null;
}

export function getSystemTheme(): AfishaTheme {
  if (typeof window === "undefined") {
    return "light";
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function hasStoredTheme(): boolean {
  return readStoredTheme() !== null;
}

export function getStoredTheme(): AfishaTheme {
  return readStoredTheme() ?? getSystemTheme();
}

export function saveTheme(theme: AfishaTheme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // ignore
  }
}

export function getNextTheme(theme: AfishaTheme): AfishaTheme {
  return theme === "light" ? "dark" : "light";
}
